var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zoom-meeting-embedded"},[(_vm.configured && !_vm.meetingStarted)?_c('button',{on:{"click":_vm.startMeeting}},[_vm._v("Join Meeting")]):_vm._e(),_c('div',{attrs:{"id":"zoomcontainerdrop"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }